import * as React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

export default function CopyrightFooter(props) {


  
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"v1.2.21 © "}
      <Link color="inherit"path="/signin">
        Italcambio
      </Link>{" "}
      {/* {"Copyright © "}
      <Link color="inherit"path="/signin">
        InterfacesLte
      </Link>{" "} */}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
